<mat-accordion multi>
  <mat-expansion-panel expanded = true *ngIf="userHasAssignedRoles()">
    <mat-expansion-panel-header>
      <mat-panel-title>
        Assigned Application Roles
      </mat-panel-title>
    </mat-expansion-panel-header>

    <ul class="assigned-roles-container">
      <li *ngFor="let role of GetAssignedRoles(platformUser.roles)" [attr.data-cy]="'user-role_' + role.name">
        <div class="assigned-roles">
          <div *ngIf="role.type != roleType.DynamicRole" class="flex flex-row flex-wrap items-center justify-start avatar-container">
            <ngx-stored-gravatar
              [name]="role.name"
              [email]="'sample'"
              [hideOnlineStatus]="true"
              [style]="defaultStyle"
            >
            </ngx-stored-gravatar>
            <div class="flex  flex-col items-start justify-start content">
              <div>{{role.name}}</div>
              <div class="tag m-t-5" >{{role.description}}</div>

            </div>
          </div>
          <button
            [disabled]="IsRemoveButtonDisabled(role)"
            (click)="onRemoveRole(role)"
            [attr.data-cy]="'user-role-remove_' + role.name"
            mat-button type="delete"
          >Remove</button>
        </div>
      </li>
    </ul>
  </mat-expansion-panel>

  <mat-expansion-panel expanded = true *ngIf="userHasDynamicRoles()">
    <mat-expansion-panel-header>
      <mat-panel-title>
        Assigned Dynamic Roles
      </mat-panel-title>
    </mat-expansion-panel-header>

    <ul class="assigned-roles-container">
      <li *ngFor="let role of GetDynamicRoles(platformUser.roles)" [attr.data-cy]="'user-role_' + role.name">
        <div class="assigned-roles" *ngIf="role.type == roleType.DynamicRole">
          <div class="flex flex-row flex-wrap items-center justify-start avatar-container">
            <ngx-stored-gravatar
              [name]="role.name"
              [email]="'sample'"
              [hideOnlineStatus]="true"
              [style]="defaultStyle"
            >
            </ngx-stored-gravatar>
            <div>{{role.name}}</div>
          </div>
        <button (click)="onRemoveRole(role)" [attr.data-cy]="'user-role-remove_' + role.name" mat-button type="delete">Remove</button>
        </div>
      </li>
    </ul>

  </mat-expansion-panel>
</mat-accordion>
